exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".network-color-css{--marker-color:var(--purple-70)}.network-color-js{--marker-color:var(--yellow-60)}.network-color-html{--marker-color:var(--blue-70)}.network-color-img{--marker-color:var(--green-70)}.network-color-other{--marker-color:var(--grey-70)}", ""]);

